/**
 * The four-point "spark" diamond from the component library (Star 8:98) as a
 * normalized inline path: centered at (0,0), height 2, width ~1.18. Scaled
 * via the `size` prop (rendered height in the parent SVG's user units).
 *
 * Used standalone for static accents and by DiamondTravel for the sparks
 * that ride the neon frame lines.
 */
export const DIAMOND_PATH =
  'M 0.59 0 C 0.197 -0.152 0.071 -0.356 0 -1 C -0.071 -0.356 -0.197 -0.152 -0.59 0 ' +
  'C -0.197 0.152 0.071 0.356 0 1 C 0.071 0.356 0.197 0.152 0.59 0 Z';

type DiamondSparkProps = {
  /** Height in the parent SVG's user units. */
  size: number;
  fill?: string;
  className?: string;
};

export function DiamondSpark({ size, fill = '#ef405b', className }: DiamondSparkProps) {
  return (
    <path d={DIAMOND_PATH} transform={`scale(${size / 2})`} fill={fill} className={className} />
  );
}
